export const UPDATE_BATCH_RESULT = "UPDATE_BATCH_RESULT";